import React from "react";
import {
  Typography,
  FormControl,
  FormLabel,
  RadioGroup,
  FormControlLabel,
  Radio,
  TextField,
  Button
} from "@material-ui/core";
import useStyles from "./PaymentForm.styles";
import { PriceFormat } from "../../../components/typography/PriceFormat";

interface PaymentAmountSelectionProps {
  balance: number;
  maxPartial: number;
  paymentType: "full" | "partial";
  amount: number;
  customAmount: number;
  defaultMinimum: number;
  isLoading: boolean;
  onPaymentTypeChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onCustomAmountChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onSubmit: (e: React.FormEvent) => void;
  disablePaymentType?: boolean;
}

const PaymentAmountSelection: React.FC<PaymentAmountSelectionProps> = ({
  balance,
  maxPartial,
  paymentType,
  amount,
  customAmount,
  defaultMinimum,
  isLoading,
  onPaymentTypeChange,
  onCustomAmountChange,
  onSubmit,
  disablePaymentType = false
}) => {
  const classes = useStyles();

  return (
    <form className={classes.form} onSubmit={onSubmit}>
      {balance ? (
        <Typography>
          Your balance:{" "}
          <b>
            <PriceFormat value={balance} />
          </b>
        </Typography>
      ) : null}
      {!disablePaymentType && balance > defaultMinimum && (
        <FormControl component="fieldset" className={classes.formItem}>
          <FormLabel component="legend">Payment Options</FormLabel>
          <RadioGroup
            value={paymentType}
            onChange={onPaymentTypeChange}
            aria-label="payment-type"
            name="payment-type"
            style={{ flexDirection: "column" }}
          >
            <FormControlLabel value="full" control={<Radio color="primary" />} label={`Pay full amount`} />
            <FormControlLabel value="partial" control={<Radio color="primary" />} label="Make a partial payment" />
          </RadioGroup>
        </FormControl>
      )}
      {(paymentType === "partial" || disablePaymentType) && (
        <TextField
          label="Amount"
          type="number"
          value={customAmount}
          onChange={onCustomAmountChange}
          InputProps={{ startAdornment: <span>€</span> }}
          inputProps={{ min: defaultMinimum, max: maxPartial, step: 1 }}
          helperText={
            <>
              Enter an amount between <PriceFormat value={defaultMinimum} /> and <PriceFormat value={maxPartial} />
            </>
          }
          fullWidth
          className={classes.formItem}
          required
        />
      )}
      <Button
        variant="contained"
        color="secondary"
        type="submit"
        disabled={
          isLoading ||
          (paymentType === "full"
            ? amount < 1 || amount > maxPartial
            : amount < 50 || amount > maxPartial || !customAmount)
        }
      >
        Proceed to Payment
      </Button>
    </form>
  );
};

export default PaymentAmountSelection;
